<template>
	<div>
		<button class="team" :class="{ selected: participant1.id == gamePick.id && gamePick.id != null}" @click="$emit('submit-pick', { gameNumber: gameData.bracket_game_number, nextGame: gameData.bracket_number_next_game, pick: participant1, otherParticipant: participant2 })">
			<div class="team__info">
				<span class="seed">{{ participant1.seed }}</span>
				<span class="team-name">{{ participant1.team.short_name }}</span>
			</div>
		</button>

		<button class="team" :class="{ selected: participant2.id == gamePick.id && gamePick.id != null}" @click="$emit('submit-pick', { gameNumber: gameData.bracket_game_number, nextGame: gameData.bracket_number_next_game, pick: participant2, otherParticipant: participant1 })">
			<div class="team__info">
				<span class="seed">{{ participant2.seed }}</span>
				<span class="team-name">{{ participant2.team.short_name }}</span>
			</div>
		</button>
	</div>
</template>

<script>
	export default {
		props: ['gameData'],
		computed: {
			participant1() {
				if(this.gameData.participants[0].id != null) {
					return this.gameData.participants[0]
				} else {
					return this.gameData.previous_game_picks[0]
				}
			},
			participant2() {
				if(this.gameData.participants[1].id != null) {
					return this.gameData.participants[1]
				} else {
					return this.gameData.previous_game_picks[1]
				}
			},
			gamePick() {
				if(this.gameData.game_pick != null) {
					return this.gameData.game_pick.participant
				} else {
					return {
						id: null,
						seed: null,
						eliminated: null,
						team: null
					}
				}
			}
		}
	}
</script>